import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.08); }
`;

export const StyledVoiceMessageBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 4px 20px rgba(18, 34, 67, 0.15);
  direction: ltr;
  width: 100%;
  box-sizing: border-box;

  .mic-button {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    min-width: 36px;
    aspect-ratio: 1;
    border: none;
    border-radius: 50%;
    background: #004ef7;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s ease;

    &.playback {
      background: #004ef7;
    }

    &.recording {
      background: #ff2d55;
      animation: ${pulse} 1.2s ease-in-out infinite;
    }
  }

  .waveform-area {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    height: 36px;
    min-width: 0;
  }

  .wave-bar {
    width: 3px;
    min-height: 12%;
    border-radius: 2px;
    background: linear-gradient(180deg, #00eab2 0%, #004ef7 100%);
    transition: height 0.08s ease;
  }

  .timer {
    flex-shrink: 0;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #122243;
    min-width: 36px;
    text-align: right;
    direction: ltr;
  }

  .hint {
    position: absolute;
    bottom: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
    font-family: "Noto Sans Hebrew", sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.85);
    text-shadow: 0 1px 4px rgba(18, 34, 67, 0.35);
    white-space: nowrap;
    pointer-events: none;
  }
`;
